import moment from "moment";
import { Skeleton, Tag } from "antd";
import hotels from "../../assets/icons/live-hotel.svg";
import Awayagent from "../../assets/icons/away-agent.svg";
import Busyagent from "../../assets/icons/busy-agent.svg";
import Oflineagent from "../../assets/icons/offline-agent.svg";
import Onlineagent from "../../assets/icons/online-agent.svg";
import CallWaiting from "../../assets/icons/call_waiting.svg";
import {
    BankOutlined,
    CompassOutlined,
    EnvironmentOutlined,
    HomeOutlined,
    MailOutlined,
    NumberOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { BsBuildings } from "react-icons/bs";
import { HiOutlinePhoneMissedCall } from "react-icons/hi";
import { LuPhoneCall, LuUserRoundCheck } from "react-icons/lu";
import { MdOutlineDoNotDisturbOn } from "react-icons/md";
import { TbUserPause } from "react-icons/tb";

export const nexusDataGrids = [
    {
        title: "Hotel",
        key: "hotel_count",
        Icon: hotels,
        SVGIcon: (
            <BsBuildings
                style={{ color: "var(--color-primary)" }}
                className="font-semibold text-2xl mb-[10px] ml-[10px]"
            />
        ),
        info: "Calling Dashboard Hotels",
    },
    {
        title: "On Call Agents",
        key: "busy_agents_counts",
        Icon: Busyagent,
        SVGIcon: (
            <LuPhoneCall
                style={{ color: "var(--color-primary)" }}
                className="font-semibold text-2xl mb-[10px] ml-[10px]"
            />
        ),
        info: "On Call Agents",
    },
    {
        title: "Offline Agents",
        key: "offline_agents_counts",
        Icon: Oflineagent,
        SVGIcon: (
            <MdOutlineDoNotDisturbOn
                style={{ color: "var(--color-primary)" }}
                className="font-semibold text-2xl mb-[10px] ml-[10px]"
            />
        ),
        info: "Offline Agents",
    },
    {
        title: "Away Agents",
        key: "away_agents_counts",
        Icon: Awayagent,
        SVGIcon: (
            <TbUserPause
                style={{ color: "var(--color-primary)" }}
                className="font-semibold text-2xl mb-[10px] ml-[10px]"
            />
        ),
        info: "Away Agents",
    },
    {
        title: "Online Agents",
        key: "online_agents_counts",
        Icon: Onlineagent,
        SVGIcon: (
            <LuUserRoundCheck
                style={{ color: "var(--color-primary)" }}
                className="font-semibold text-2xl mb-[10px] ml-[10px]"
            />
        ),
        info: "Online Agents",
    },
    {
        title: "Calls Waiting",
        key: "call_waiting_counts",
        Icon: CallWaiting,
        SVGIcon: (
            <HiOutlinePhoneMissedCall
                style={{ color: "var(--color-primary)" }}
                className="font-semibold text-2xl mb-[10px] ml-[10px]"
            />
        ),
        info: "Number of waiting calls",
    },
];

export function getStatusEndpoint(agentStatusKey) {
    switch (agentStatusKey) {
        case "busy_agents_counts":
            return {
                endpoint: "getNexusBusyAgents",
                agent_status: 2,
            };
        case "offline_agents_counts":
            return {
                endpoint: "getNexusOfflineAgents",
                agent_status: 5,
            };
        case "away_agents_counts":
            return {
                endpoint: "getNexusAwayAgents",
                agent_status: 3,
            };
        case "online_agents_counts":
            return {
                endpoint: "getNexusOnlineAgents",
                agent_status: 1,
            };
        case "call_waiting_counts":
            return {
                endpoint: "getNexusCallWaitingDetails",
                // agent_status: 1,
            };
        default:
            break;
    }
}

const getAgentName = (record = {}) =>
    [record.first_name, record.last_name].filter(Boolean).join(" ").trim();

const renderEmptyValue = (label = "-") => (
    <span style={{ color: "var(--color-text-muted)" }}>{label}</span>
);

const AgentNameCell = ({ record }) => {
    const agentName = getAgentName(record);

    if (!agentName) {
        return renderEmptyValue("Unassigned");
    }

    const initials = agentName
        .split(" ")
        .slice(0, 2)
        .map((part) => part[0])
        .join("")
        .toUpperCase();

    return (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
                style={{
                    width: 30,
                    height: 30,
                    borderRadius: 10,
                    background: "var(--color-primary-light)",
                    border: "1px solid var(--color-border)",
                    color: "var(--color-primary)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    fontSize: 12,
                    fontWeight: 700,
                }}
            >
                {initials || <UserOutlined />}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <span
                    style={{
                        color: "var(--color-text)",
                        fontSize: 13,
                        fontWeight: 600,
                    }}
                >
                    {agentName}
                </span>
                <span
                    style={{
                        color: "var(--color-text-muted)",
                        fontSize: 11,
                    }}
                >
                    Agent
                </span>
            </div>
        </div>
    );
};

const HotelAssignmentsCell = ({ hotels = [] }) => {
    const visibleHotels = hotels.filter(Boolean).slice(0, 4);
    const hiddenCount = Math.max((hotels?.length || 0) - visibleHotels.length, 0);

    if (!visibleHotels.length) {
        return renderEmptyValue("No hotels assigned");
    }

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                flexWrap: "wrap",
            }}
        >
            {visibleHotels.map((hotel) => (
                <Tag
                    key={hotel.hotel_id || hotel.hotel_name}
                    style={{
                        background: "var(--color-bg-control)",
                        border: "1px solid var(--color-border)",
                        color: "var(--color-text-secondary)",
                        borderRadius: 6,
                        fontSize: 12,
                        margin: 0,
                        maxWidth: 260,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                    title={hotel.hotel_name}
                >
                    {hotel.hotel_name || "Unnamed hotel"}
                </Tag>
            ))}
            {hiddenCount > 0 && (
                <span
                    style={{
                        color: "var(--color-text-muted)",
                        fontSize: 12,
                        fontWeight: 600,
                    }}
                >
                    +{hiddenCount} more
                </span>
            )}
        </div>
    );
};

export const getNexusColumns = (
    sortedInfo,
    agent_status,
    selectedTab,
    handleClick = null,
) => {
    if (agent_status != "call_waiting_counts") {
        return [
            {
                title: "Agent Name",
                key: "first_name",
                render: (record) => <AgentNameCell record={record} />,
                sorter: () => {},
                // defaultSortOrder: "descend",
                sortOrder:
                    sortedInfo.columnKey === "first_name"
                        ? sortedInfo.order
                        : null,
                width: "34%",
            },
            {
                title: "Hotel Name",
                render: (record) => (
                    <HotelAssignmentsCell hotels={record?.hotels} />
                ),
            },
        ];
    } else {
        let callWaitingColumn = [
            {
                title: "Hotel Name",
                dataIndex: "hotel_name",
                key: "hotel_name",
                sorter: () => {},
                sortOrder:
                    sortedInfo.columnKey === "hotel_name"
                        ? sortedInfo.order
                        : null,
                width: "40%",
                render: (text, record) =>
                    selectedTab && selectedTab === "history" ? (
                        <span
                            onClick={() =>
                                handleClick("call-waiting-history", record)
                            }
                            id={record.hotel_id}
                            data-hotelname={text}
                            style={{ color: "#1890ff", cursor: "pointer" }}
                        >
                            {text}
                        </span>
                    ) : (
                        <span>{text}</span>
                    ),
            },
            {
                title: "Kiosk Nickname",
                dataIndex: "kiosk_nickname",
                key: "kiosk_nickname",
                sorter: () => {},
                sortOrder:
                    sortedInfo.columnKey === "kiosk_nickname"
                        ? sortedInfo.order
                        : null,
                width: "30%",
            },
        ];
        if (selectedTab && selectedTab === "history") {
            callWaitingColumn.push({
                title: "Waiting calls",
                dataIndex: "calls_waiting",
                key: "calls_waiting",
                sorter: () => {},
                sortOrder:
                    sortedInfo.columnKey === "calls_waiting"
                        ? sortedInfo.order
                        : null,
            });
        }
        return callWaitingColumn;
    }
};

const NEXUS_HOTEL_AVATAR_COLORS = [
    "#4e9af1",
    "#fe8447",
    "#4caf7d",
    "#b06de3",
    "#e05c7a",
    "#f0c040",
    "#36c2cf",
    "#ff7043",
];

function getNexusHotelAvatarColor(name = "") {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return NEXUS_HOTEL_AVATAR_COLORS[
        Math.abs(hash) % NEXUS_HOTEL_AVATAR_COLORS.length
    ];
}

function NexusHotelAvatar({ name = "" }) {
    const initials = name
        .split(" ")
        .slice(0, 2)
        .map((word) => word[0])
        .join("")
        .toUpperCase();
    const color = getNexusHotelAvatarColor(name);

    return (
        <div
            style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                background: `${color}22`,
                border: `1.5px solid ${color}55`,
                color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: 13,
                flexShrink: 0,
                letterSpacing: 0.5,
            }}
        >
            {initials || "H"}
        </div>
    );
}

const renderEmptyHotelValue = () => (
    <span style={{ color: "var(--color-text-muted)" }}>-</span>
);

export const nexusHotelColumns = [
    {
        title: (
            <span className="nexus-hotel-table-heading">
                <NumberOutlined /> ID
            </span>
        ),
        dataIndex: "id",
        key: "id",
        sorter: () => {},
        width: 96,
        render: (id) => (
            <span className="nexus-hotel-table-id-chip">#{id}</span>
        ),
    },
    {
        title: (
            <span className="nexus-hotel-table-heading">
                <BankOutlined /> Hotel Name
            </span>
        ),
        dataIndex: "name",
        key: "name",
        sorter: () => {},
        width: 280,
        render: (name) => (
            <div className="nexus-hotel-table-identity">
                <NexusHotelAvatar name={name} />
                <div className="nexus-hotel-table-identity-copy">
                    <span className="nexus-hotel-table-identity-title">
                        {name || "Unnamed hotel"}
                    </span>
                    <span className="nexus-hotel-table-identity-subtitle">
                        Calling dashboard hotel
                    </span>
                </div>
            </div>
        ),
    },
    {
        title: (
            <span className="nexus-hotel-table-heading">
                <HomeOutlined /> Street
            </span>
        ),
        dataIndex: "street",
        key: "street",
        sorter: () => {},
        render: (street) =>
            street ? (
                <span className="nexus-hotel-table-muted-copy">{street}</span>
            ) : (
                renderEmptyHotelValue()
            ),
    },
    {
        title: (
            <span className="nexus-hotel-table-heading">
                <EnvironmentOutlined /> City
            </span>
        ),
        dataIndex: "city",
        key: "city",
        sorter: () => {},
        render: (city) =>
            city ? (
                <div className="nexus-hotel-table-location">
                    <EnvironmentOutlined className="nexus-hotel-table-location-icon" />
                    <span>{city}</span>
                </div>
            ) : (
                renderEmptyHotelValue()
            ),
    },
    {
        title: (
            <span className="nexus-hotel-table-heading">
                <CompassOutlined /> State
            </span>
        ),
        dataIndex: "state",
        key: "state",
        sorter: () => {},
        width: 120,
        render: (state) =>
            state ? (
                <Tag className="nexus-hotel-table-state-tag">
                    {state.toUpperCase()}
                </Tag>
            ) : (
                renderEmptyHotelValue()
            ),
    },
    {
        title: (
            <span className="nexus-hotel-table-heading">
                <MailOutlined /> Zipcode
            </span>
        ),
        dataIndex: "zipcode",
        key: "zipcode",
        sorter: () => {},
        width: 130,
        render: (zipcode) => (
            <span className="nexus-hotel-table-zip-chip">{zipcode || "-"}</span>
        ),
    },
];

export const LoadingComponent = () => {
    return (
        <Skeleton active title={false} paragraph={{ rows: 10, width: 40 }} />
    );
};

export const calculateWaitingTime = (record) => {
    const startTime =
        record.call_start_at_kiosk_time || record.call_start_at_staff_time;

    if (!startTime || !record.missed_call_at) return "-";
    const start = moment(startTime);
    const end = moment(record.missed_call_at);
    const diffSeconds = end.diff(start, "seconds");

    const hours = Math.floor(diffSeconds / 3600);
    const minutes = Math.floor((diffSeconds % 3600) / 60);
    const seconds = diffSeconds % 60;

    let formattedTime = "";
    if (hours > 0) {
        formattedTime += `${hours}h `;
    }
    if (minutes > 0) {
        formattedTime += `${minutes}m `;
    }
    formattedTime += `${seconds}s`;

    return formattedTime.trim();
};

export  const getDateTimeRangeOptions = () => ({
    Today: [moment().startOf("day"), moment()],
    Yesterday: [moment().subtract(1, "day").startOf("day"), moment().subtract(1, "day").endOf("day")],
    "Last 15 Minutes": [moment().subtract(15, "minutes"), moment()],
    "Last 30 Minutes": [moment().subtract(30, "minutes"), moment()],
    "Last 1 Hour": [moment().subtract(1, "hour"), moment()],
    "Last 3 Hours": [moment().subtract(3, "hours"), moment()],
    "Last 7 Days": [moment().subtract(7, "days"), moment()],
    "Last 30 Days": [moment().subtract(30, "days"), moment()],
    "Current Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
    "Last 3 Months": [moment().subtract(3, "months"), moment()],
  });
